import { css } from "@emotion/css"
import { Loading } from "components/Loading"
import { CircularProgressWithLabel } from "../SharedComponents/CircularProgressWithLabel"
import { StatsPieInfo } from "./StatsPieInfo"

const styles = {
  widgetStatsPie: css`
    height: 136px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: var(--spacing-m);
    margin: 24 0 0 0;
    border-radius: 10px;
  `,
  info: css`
    height: 70px;
    display: flex;
    gap: 2px;
    flex-direction: column;
    flex-grow: 0;
    justify-content: flex-start;
    align-items: flex-start;
  `,
  circle: css`
    background-color: transparent;
    z-index: 2;
    border: 4px solid #373739;
    height: 88px;
    border-radius: 50%;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    width: 88px;
    position: relative;
    margin-top: var(--spacing-xs);
  `,
  circleText: css`
    color: var(--white);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
}

const NullWidgetStatsPie = () => {
  return (
    <div className={styles.circle}>
      <div className={styles.circleText}>N/A</div>
    </div>
  )
}

type WidgetStatsPieProps = {
  currency: string
  current?: number
  note: string
  percentage?: number | null
  subnote: string
  subnote2?: string
  className: string
  isLoading?: boolean
  hasNoDataToShow: boolean
}
export const WidgetStatsPie = (props: WidgetStatsPieProps) => {
  const {
    currency,
    current,
    note,
    subnote,
    percentage,
    subnote2,
    className,
    isLoading,
    hasNoDataToShow,
  } = props

  return (
    <>
      <div className={styles.widgetStatsPie}>
        {isLoading ? null : hasNoDataToShow ? (
          <NullWidgetStatsPie />
        ) : (
          <CircularProgressWithLabel
            percentage={percentage || 0}
            className={className}
          />
        )}

        {isLoading ? (
          <Loading />
        ) : (
          <div className={styles.info}>
            <StatsPieInfo
              currency={currency}
              current={current}
              percentage={percentage}
              note={note}
              subnote={subnote}
              subnote2={subnote2}
            />
          </div>
        )}
      </div>
    </>
  )
}
